import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CustomerDataService } from '../shared/services/customer-data.service';

interface IResponseGetPublicKey {
  publicKey: string;
}

@Injectable({
  providedIn: 'root'
})
export class GetPublicPassiveKeyService {
  private readonly BASE_URL = `${environment.baseUrl}/get-passive-public-key`;

  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization-token':
        this.customerDataService.customerData.tokenaAuthorization
    })
  };

  constructor(
    private http: HttpClient,
    private customerDataService: CustomerDataService
  ) {}

  getKey(): Observable<HttpResponse<IResponseGetPublicKey>> {
    return this.http.get<IResponseGetPublicKey>(this.BASE_URL, {
      ...this.httpOptions,
      observe: 'response'
    });
  }
}
